import React, { useEffect, useState } from 'react'
import { withTranslation } from 'react-i18next'
import withRouter from '../../../components/Common/withRouter'
import { useParams } from "react-router-dom"
import Leger from './Leger'
import TrialBalance from './TrialBalance'

// Constants
const TABS = {
  LEGER: 'leger',
  TRIAL_BALANCE: 'trial_balance'
}

const Trial = ({ t }) => {
  const { param } = useParams()
  const [activeTab, setActiveTab] = useState(TABS.LEGER)


  // Handle tab change
  const handleTabChange = (target) => {
    setActiveTab(target)
  }

  // Set active tab based on URL param
  useEffect(() => {
    if (param) {
      handleTabChange(param)
    }
  }, [param])

  // Tab configuration
  const tabConfig = [
    {
      id: TABS.LEGER,
      icon: 'fa fa-user ms-1 me-2',
      label: t("leger"),
      target: '#all_patients',
      controls: 'home'
    },
    {
      id: TABS.TRIAL_BALANCE,
      icon: 'fa fa-user me-2',
      label: t("trial_balance"),
      target: '#admit-patient',
      controls: 'admit-patient'
    }
  ]

  // Render tab navigation
  const renderTabNavigation = () => (
    <ul className="nav nav-tabs nav-underline ps-2 pe-2" id="myTab" role="tablist">
      {tabConfig.map((tab, index) => (
        <li
          key={tab.id}
          className={`nav-item ${index > 0 ? 'px-2' : ''}`}
          role="presentation"
        >
          <button
            className={`nav-link ${activeTab === tab.id ? 'active' : ''}`}
            id={`${tab.id}-tab`}
            data-bs-toggle="tab"
            data-bs-target={tab.target}
            type="button"
            role="tab"
            aria-controls={tab.controls}
            aria-selected={activeTab === tab.id}
            onClick={() => handleTabChange(tab.id)}
          >
            <i className={tab.icon} aria-hidden="true"></i>
            {tab.label}
          </button>
        </li>
      ))}
    </ul>
  )

  // Render tab content
  const renderTabContent = () => (
    <div className="tab-content" id="myTabContent">
      {/* Leger Tab */}
      <div
        className={`tab-pane fade ${activeTab === TABS.LEGER ? 'show active' : ''} card border-0`}
        id="leger"
        role="tabpanel"
        aria-labelledby="home-tab"
      >
        <div className="card-header">
          <Leger
            className="px-0"
            isActive={activeTab === TABS.LEGER}
          />
        </div>
      </div>

      {/* Trial Balance Tab */}
      <div
        className={`tab-pane fade ${activeTab === TABS.TRIAL_BALANCE ? 'show active' : ''} card border-0`}
        id="trial_balance"
        role="tabpanel"
        aria-labelledby="trial_balance-tab"
      >
        <div className="card-header">
          <TrialBalance
            className="px-0"
            isActive={activeTab === TABS.TRIAL_BALANCE}
          />
        </div>
      </div>
    </div>
  )

  return (
    <div className="patients-list-content">
      <div className="patients-list py-4 px-2">
        <div className="container-fluide px-5">
          {/* Header */}
          <div className="row list-patients d-flex align-items-center justify-content-between">
            <div className="col-lg-4">
              <h6>{t("report")}</h6>
            </div>
          </div>

          {/* Tabs Section */}
          <div className="row py-2">
            {renderTabNavigation()}
            {renderTabContent()}
          </div>
        </div>
      </div>
    </div>
  )
}

export default withRouter(withTranslation()(Trial))